
function defineAlias ({target, originalName, proxy = target, alias = originalName, writable, configurable, fastMode}) {

    if (proxy === target && alias === originalName) {
        return
    }

    const options = {
        enumerable: true,
        configurable
    }

    let boundMethod = getBoundMethod(proxy, target, target[originalName])

    if (fastMode) {
        if (boundMethod) {
            options.get = () => boundMethod
        } else {
            options.get = () => target[originalName]
        }
    } else {
        options.get = () => getBoundMethod(proxy, target, target[originalName]) || target[originalName]
    }


    if (writable !== false) {
        options.set = function (value) {
            target[originalName] = value
        }
    }

    Object.defineProperty(proxy, alias, options)

}


function getBoundMethod (proxy, target, method) {
    if (typeof method === "function" && proxy !== target) {
        return method.bind(target)
    } else {
        return false
    }
}


function defineSameNameAliases ({proxy, target, writable, configurable, fastMode}, keys) {
    keys.forEach((key) => {
        defineAlias({
            proxy,
            target,
            writable,
            configurable,
            fastMode,
            originalName: key
        })
    })
}


function defineProxifiedAliases ({proxy, target, writable, configurable, fastMode}, keys) {
    for (let key in keys) {
        let aliases = (typeof keys[key] === "string") ? [keys[key]] : keys[key]
        aliases.forEach((alias) => {
            defineAlias({
                proxy,
                target,
                writable,
                configurable,
                alias,
                fastMode,
                originalName: key
            })
        })
    }
}



export default function (params) {

    let {key, keys, proxy} = params

    if (typeof key === "string") {

        if (proxy) {
            let {target, writable, fastMode, configurable} = params
            defineAlias({
                proxy,
                target,
                writable,
                configurable,
                fastMode,
                originalName: key
            })
        } else {
            console.warn('Alias : "key" param is a simple string -> "proxy" param should be specified !')
        }

    } else if (keys instanceof Array) {

        if (proxy) {
            defineSameNameAliases(params, keys)
        } else {
            console.warn('Alias : "keys" param is a simple array -> "proxy" param should be specified !')
        }

    } else {

        defineProxifiedAliases(params, keys || key)

    }

}


